/*
 * Build shim (build tooling only — no runtime behavior change).
 *
 * fontkit 2.x ships Parcel-generated modules whose exports are defined via
 * getters (`Object.defineProperty(exports, 'create', { get })`) and marked
 * `__esModule`. webpack 4 (react-scripts 4) does a strict ESM named-export
 * check for `import * as fontkit; fontkit.create(...)` (used by
 * @react-pdf/pdfkit and @react-pdf/font) and cannot see getter-defined
 * exports, so it fails with "'create' is not exported from 'fontkit'".
 *
 * This shim CommonJS-`require`s the real fontkit (aliased to `fontkit-cjs`),
 * where the getters resolve normally, and re-exports the bindings as real,
 * statically-analyzable ES module exports. webpack's `fontkit` alias points
 * every `import ... from 'fontkit'` here. Same library, same runtime.
 */
/* eslint-disable */
const fontkit = require('fontkit-cjs');

export const create = fontkit.create;
export const open = fontkit.open;
export const openSync = fontkit.openSync;
export const defaultLanguage = fontkit.defaultLanguage;
export const setDefaultLanguage = fontkit.setDefaultLanguage;
export const logErrors = fontkit.logErrors;
export const registerFormat = fontkit.registerFormat;

export default fontkit;
